export default "__VITE_ASSET__DHIs1u9J__"